export default {
	methods: {
		displayListAfterClearing(listName){
			this.lists = []
			this.displayList(listName)
		}
	}
}